@let versionId = this.versionId();
@if (versionId !== null) {
  <span class="flex flex-col h-full justify-center">
    <pm-link
      variant="subdued"
      [text]="this.dateLabel()"
      (handleClick)="onOpen(versionId)"
      size="large"
    />
  </span>
}
